// @flow strict

import * as React from 'react';
import PageContentBlock from '../../internal/PageContentBlock';
import FormattedContent from '../../internal/FormattedContent';
import type { CompleteRichText } from '../../internal/types';

const blockVariantMap = {
  Low: 'Featured',
  Medium: 'Default',
  High: 'DefaultContrast',
  Dark: 'Dark',
  NoMargin: 'NoMargin',
};

type PropTypes = {|
  children: CompleteRichText,
  background: 'Low' | 'Medium' | 'High' | 'Dark' | 'NoMargin',
|};

const RichText = (props: PropTypes) => {
  return (
    <PageContentBlock background={blockVariantMap[props.background]} compact layout="Thin">
      <FormattedContent isDarkBackground={props.background === 'Dark'} variant="Secondary">
        {props.children}
      </FormattedContent>
    </PageContentBlock>
  );
};

RichText.defaultProps = {
  background: 'Medium',
};

export default RichText;
